import { QuestionExplanation } from '../../types'

export const METRIEK_EXPLANATIONS: Record<string, QuestionExplanation> = {
  'MET-OMT-L1-001': {
    id: 'MET-OMT-L1-001',
    explanation:
      'Je loopt helemaal rond de tuin. Tel alle kanten op: 12 + 8 + 12 + 8 = 40 meter.',
    distractorExplanations: {
      '0': 'Je telde maar 2 kanten (12 + 8). Een tuin heeft 4 kanten!',
      '2': 'Je deed 12 × 8. Dat is de oppervlakte, niet de omtrek!',
      '3': 'Bijna! Tel de vier kanten bij elkaar op: 12 + 8 + 12 + 8.',
    },
    visualAid: { type: 'geo', data: { width: 12, height: 8, mode: 'perimeter', label: 'Omtrek van de tuin' }, showWhen: 'wrong' },
  },
  'MET-OMT-L2-001': {
    id: 'MET-OMT-L2-001',
    explanation:
      'Eerst reken je één rondje uit: 10 + 5 + 10 + 5 = 30 meter. Dan keer 3: 30 × 3 = 90 meter.',
    distractorExplanations: {
      '0': 'Je deed iets bij 30, maar vergat ×3 te doen.',
      '1': 'Dit is maar één rondje! Je moest 3 rondjes lopen.',
      '3': 'Je deed 10 × 5 (inhoud) en toen ×3. Maar we willen omtrek keer 3.',
    },
    visualAid: { type: 'geo', data: { width: 10, height: 5, mode: 'perimeter', label: 'Zwembad (1 rondje = 30m)' }, showWhen: 'wrong' },
  },
  'MET-INH-L1-001': {
    id: 'MET-INH-L1-001',
    explanation: '1,5 liter = 1500 ml. 1500 ÷ 250 = 6 glazen.',
    distractorExplanations: {
      '0': 'Je gebruikte 1 liter (1000 ml). Maar er zit 1,5 liter in de fles!',
      '2': 'Check nog eens: 1500 ÷ 250 = 6.',
      '3': 'Let op: 1,5 liter = 1500 ml, niet 15.000 ml.',
    },
    visualAid: { type: 'stairs', data: { type: 'volume', from: 'l', to: 'ml', value: 1.5, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-OPP-L3-002': {
    id: 'MET-OPP-L3-002',
    explanation: 'Bij een vierkant zijn alle zijden even lang. Welk getal × zichzelf = 36? Dat is 6, want 6 × 6 = 36.',
    distractorExplanations: {
      '1': 'Je deed 36 ÷ 4. Dat is voor omtrek, niet oppervlakte!',
      '2': 'Je deed 36 ÷ 2. Maar zoek een getal × zichzelf = 36.',
      '3': 'Te klein! 4 × 4 = 16. Dat is geen 36.',
    },
    visualAid: { type: 'geo', data: { width: 6, height: 6, mode: 'area', label: 'Vierkant: 6 × 6 = 36 cm²' }, showWhen: 'wrong' },
  },
  'MET-LEN-L2-002': {
    id: 'MET-LEN-L2-002',
    explanation: 'Van km naar dm zijn 4 trapjes omlaag. 4,5 × 10 × 10 × 10 × 10 = 45.000 dm.',
    distractorExplanations: {
      '0': 'Te vroeg gestopt! Van km naar dm zijn 4 stappen.',
      '1': 'Je stopte bij meter. Nog één stapje naar dm!',
      '3': 'Eén stapje te ver! Je kwam bij cm uit.',
    },
    visualAid: { type: 'stairs', data: { type: 'length', from: 'km', to: 'dm', value: 4.5, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-INH-L3-001': {
    id: 'MET-INH-L3-001',
    explanation: 'Inhoud = lengte × breedte × hoogte = 5 × 4 × 3 = 60 liter.',
    distractorExplanations: {
      '0': 'Je deed 5 + 4 + 3. Maar moet × elkaar doen!',
      '2': 'Check nog eens: 5 × 4 × 3 = 60.',
      '3': 'Je deed alleen de bodem (5 × 4). Vergeet hoogte niet!',
    },
    visualAid: { type: 'rule', data: { title: 'Inhoud Berekenen', content: 'Inhoud = lengte × breedte × hoogte', icon: 'lightbulb' }, showWhen: 'wrong' },
  },
  'MET-OPP-L1-001': {
    id: 'MET-OPP-L1-001',
    explanation: 'Tegels gaan op de vloer. Dat is lengte × breedte = 8 × 6 = 48 m².',
    distractorExplanations: {
      '0': 'Je deed 8 + 6. Maar bij vloeroppervlakte moet je × doen!',
      '2': 'Je rekende omtrek (8+6+8+6). Maar we willen vloeroppervlakte!',
      '3': 'Het getal klopt, maar let op: het is m², niet m.',
    },
    visualAid: { type: 'geo', data: { width: 8, height: 6, mode: 'area', label: 'Klaslokaal: 8 × 6 = 48 m²' }, showWhen: 'wrong' },
  },
  'MET-LEN-L2-001': {
    id: 'MET-LEN-L2-001',
    explanation: '1,5 km = 1500 meter. (1,5 × 1000)',
    distractorExplanations: {
      '0': 'Je stopte bij hectometer. Nog één stapje naar meter!',
      '2': 'Je deelde in plaats van × gedaan.',
      '3': 'Te veel nullen! 1,5 × 1000 = 1500.',
    },
    visualAid: { type: 'stairs', data: { type: 'length', from: 'km', to: 'm', value: 1.5, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-INH-L2-001': {
    id: 'MET-INH-L2-001',
    explanation: '1 L = 10 dl. 10 - 2 = 8 dl over.',
    distractorExplanations: {
      '0': 'Je probeerde 1 - 0,2. Zet eerst alles in dl!',
      '2': 'Je dacht 1 L = 100 dl. Let op: 1 L = 10 dl!',
      '3': 'Je deed erbij in plaats van eraf.',
    },
    visualAid: { type: 'stairs', data: { type: 'volume', from: 'l', to: 'dl', value: 1, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-OMT-L3-001': {
    id: 'MET-OMT-L3-001',
    explanation: 'Twee lange kanten = 200 m. Rest = 100 m voor twee korte kanten. Elke korte kant = 50 m.',
    distractorExplanations: {
      '0': 'Dit is voor de twee korte kanten samen. Deel nog door 2!',
      '2': 'Dan zou het een vierkant zijn. Check: 100+100+100+100=400.',
      '3': 'Je deed 300 ÷ 2. Maar haal eerst de lange kanten eraf!',
    },
    visualAid: { type: 'rule', data: { title: 'Omtrek Terugrekenen', content: 'Als je de omtrek weet, kun je een kant uitrekenen.', icon: 'lightbulb' }, showWhen: 'wrong' },
  },
  'MET-OPP-L3-001': {
    id: 'MET-OPP-L3-001',
    explanation: 'Vierkant: 9 × 9 = 81 cm². Zijkant = 9 cm.',
    distractorExplanations: {
      '1': 'Je deed 81 ÷ 4. Dat is omtrek, niet oppervlakte!',
      '2': '81 ÷ 2. Maar zoek een getal × zichzelf = 81.',
      '3': 'Dit is hoeveelheid erin, niet lengte zijde.',
    },
    visualAid: { type: 'geo', data: { width: 9, height: 9, mode: 'area', label: 'Vierkant: 9 × 9 = 81 cm²' }, showWhen: 'wrong' },
  },
  'MET-LEN-L1-002': {
    id: 'MET-LEN-L1-002',
    explanation: '250 cm = 2,5 m (250 ÷ 100).',
    distractorExplanations: {
      '0': 'Je deelde door 1000. Dat is van mm naar m!',
      '2': 'Je deelde door 10. Dat is cm → dm!',
      '3': 'Zelfde getal, maar niet in meters.',
    },
    visualAid: { type: 'stairs', data: { type: 'length', from: 'cm', to: 'm', value: 250, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-GEW-L1-001': {
    id: 'MET-GEW-L1-001',
    explanation: '3 kg = 3000 g (3 × 1000).',
    distractorExplanations: {
      '0': '×10 is te weinig.',
      '1': '×100 is naar dag, niet gram.',
      '3': '1 kg = 1000 g, dus 3 kg = 3000 g.',
    },
    visualAid: { type: 'stairs', data: { type: 'weight', from: 'kg', to: 'g', value: 3, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-OMT-L1-002': {
    id: 'MET-OMT-L1-002',
    explanation: 'Omtrek = 9+4+9+4 = 26 m.',
    distractorExplanations: {
      '0': 'Tel alle vier kanten!',
      '2': '9×4 = oppervlakte, niet omtrek!',
      '3': 'Hoeveel erin past × 2 klopt niet.',
    },
    visualAid: { type: 'geo', data: { width: 9, height: 4, mode: 'perimeter', label: 'Omtrek: 9 + 4 + 9 + 4 = 26 m' }, showWhen: 'wrong' },
  },
  'MET-INH-L1-002': {
    id: 'MET-INH-L1-002',
    explanation: '7,5 ÷ 1,5 = 5 flessen.',
    distractorExplanations: {
      '0': '3 flessen = 4,5 L. Te weinig.',
      '1': '4 flessen = 6 L. Nog 1,5 L over.',
      '3': '6 flessen = 9 L. Te veel.',
    },
    visualAid: { type: 'rule', data: { title: 'Verdelen', content: '7,5 ÷ 1,5 = 5 flessen', icon: 'lightbulb' }, showWhen: 'wrong' },
  },
  'MET-OPP-L2-001': {
    id: 'MET-OPP-L2-001',
    explanation: 'Oppervlakte = 4 × 3,5 = 14 m².',
    distractorExplanations: {
      '0': '4+3,5? Nee, × doen.',
      '2': 'Verdubbeling is fout.',
      '3': '4×3=12, vergeet 0,5 m bij breedte.',
    },
    visualAid: { type: 'geo', data: { width: 4, height: 3.5, mode: 'area', label: 'Oppervlakte: 4 × 3,5 = 14 m²' }, showWhen: 'wrong' },
  },
  'MET-INH-L2-002': {
    id: 'MET-INH-L2-002',
    explanation: '2 m = 20 dm, 50 cm = 5 dm, 20 cm = 2 dm → 20×5×2=200 dm³',
    distractorExplanations: {
      '0': 'Tel de getallen? Nee, × elkaar.',
      '2': 'Check omzetting en berekening.',
      '3': 'Reken eerst alles om naar dm!',
    },
    visualAid: { type: 'rule', data: { title: 'Inhoud in dm³', content: 'Stap 1: omzetting naar dm\nStap 2: 20×5×2=200 dm³', icon: 'lightbulb' }, showWhen: 'wrong' },
  },
  'MET-INH-L3-002': {
    id: 'MET-INH-L3-002',
    explanation: '18.000 L ÷ 1000 = 18 m³.',
    distractorExplanations: {
      '0': 'Delen door 10.000? Nee.',
      '2': 'Delen door 100? Nee.',
      '3': 'Delen door 10? Te weinig.',
    },
    visualAid: { type: 'stairs', data: { type: 'volume', from: 'l', to: 'm3', value: 18000, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-LEN-L3-001': {
    id: 'MET-LEN-L3-001',
    explanation: '120 m = 12.000 cm → 12.000 ÷ 40 = 300 tegels.',
    distractorExplanations: {
      '0': '120 ÷ 4? Maten kloppen niet.',
      '1': '1200 ÷ 40? Te klein.',
      '3': '12.000 ÷ 40 = 300.',
    },
    visualAid: { type: 'rule', data: { title: 'Gelijke Maten', content: 'Reken nooit meters en cm door elkaar.', icon: 'alert' }, showWhen: 'wrong' },
  },
  'MET-GEW-L1-002': {
    id: 'MET-GEW-L1-002',
    explanation: '1000 g ÷ 200 g = 5 appels.',
    distractorExplanations: {
      '1': '1000 ÷ 100? Appel weegt 200 g.',
      '2': '1000 ÷ 500? Appel = 200 g.',
      '3': '1000 ÷ 50? Appel = 200 g.',
    },
    visualAid: { type: 'stairs', data: { type: 'weight', from: 'kg', to: 'g', value: 1, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-GEW-L2-001': {
    id: 'MET-GEW-L2-001',
    explanation: '2,5 kg × 1000 = 2.500 g.',
    distractorExplanations: {
      '1': '×100 is decagram.',
      '2': '×10 is hectogram.',
      '3': 'Te veel nullen! 2,5 × 1000 = 2.500 g.',
    },
    visualAid: { type: 'stairs', data: { type: 'weight', from: 'kg', to: 'g', value: 2.5, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-INH-L2-003': {
    id: 'MET-INH-L2-003',
    explanation: '8 L = 8000 ml ÷ 500 ml = 16 bekers.',
    distractorExplanations: {
      '1': '8 ÷ 0,5 klopt niet.',
      '2': '8.000 ÷ 1000 = 8? Fout.',
      '3': '8.000 ÷ 250 = 32? Nee.',
    },
    visualAid: { type: 'stairs', data: { type: 'volume', from: 'l', to: 'ml', value: 8, showAnimation: true }, showWhen: 'wrong' },
  },
  'MET-GEW-L3-001': {
    id: 'MET-GEW-L3-001',
    explanation: '3.500 - 2.750 = 750 kg mag nog bij.',
    distractorExplanations: {
      '1': 'Rekenfout: 3.500 - 2.750 ≠ 850',
      '2': 'Rekenfout: 3.500 - 2.750 ≠ 650',
      '3': 'Je deed 3.500 - 2.500. Fout.',
    },
    visualAid: { type: 'rule', data: { title: 'Maximaal Gewicht', content: 'Max gewicht - al in vracht = over', icon: 'lightbulb' }, showWhen: 'wrong' },
  },
  'MET-INH-L3-003': {
    id: 'MET-INH-L3-003',
    explanation: '50×30×40=60.000 cm³ ÷ 1000 = 60 liter.',
    distractorExplanations: {
      '1': 'Dacht 60.000 = liter? Deel door 1000!',
      '2': 'Alleen 50×30 ÷50? Fout.',
      '3': '50×30×40 zonder omrekenen naar liter.',
    },
    visualAid: { type: 'rule', data: { title: 'Inhoud: cm³ naar liter', content: 'Stap 1: cm³ berekenen\nStap 2: ÷1000 = liter', icon: 'lightbulb' }, showWhen: 'wrong' },
  },
}
